const nextNumber = (key) => {
  const current = Number(localStorage.getItem(key) || 0) + 1;
  localStorage.setItem(key, String(current));
  return String(current).padStart(6, '0');
};

export const createPatientCode = () => `PAT-${new Date().getFullYear()}-${nextNumber('cliniquePatientSequence')}`;
export const createInsuranceCode = () => `ASS-${new Date().getFullYear()}-${nextNumber('cliniqueInsuranceSequence')}`;
export const createReceiptCode = () => `REC-${new Date().getFullYear()}-${nextNumber('cliniqueReceiptSequence')}`;
export const createLabOrderCode = () => `LAB-${new Date().getFullYear()}-${nextNumber('cliniqueLabSequence')}`;
